import React, { useState } from 'react'
import useStore from '../../hooks/use_store'
import { useQuery } from '@tanstack/react-query'
import { Badge, Button, EmptyState } from '@cinesend/ui-kit'
import DataTable from '../../components/data_table'
import EditModal from './edit_modal'

const FieldValidatorsTable = () => {
  const [perPage, setPerPage] = useState(25)
  const [page, setPage] = useState(0)
  const {
    data: validators,
    error,
    isLoading,
    refetch,
  } = useQuery([`validator-field-types?page=${page}&per_page=${perPage}`])
  const [showModal, setShowModal] = useState(false)
  const [validator, setValidator] = useState({})
  const { createModel } = useStore()
  const fieldTypes = validators?.field_types || []

  const onToggleChange = (validatorId, fieldType, isEnabled) => {
    createModel.mutate({
      endpoint: 'validator-field-types',
      data: {
        validator_id: validatorId,
        field_type: fieldType,
        enabled: isEnabled,
      },
      onSuccess: () => {
        validators.data.find((v) => v.id === validatorId).field_types.find((ft) => ft.field_type === fieldType)
          ? (validators.data
              .find((v) => v.id === validatorId)
              .field_types.find((ft) => ft.field_type === fieldType).enabled = isEnabled)
          : validators.data
              .find((v) => v.id === validatorId)
              .field_types.push({ field_type: fieldType, enabled: isEnabled })
      },
    })
  }

  const openEditModal = (data) => {
    setValidator(data)
    setShowModal(true)
  }

  const columns = [
    {
      key: 'validator',
      header: 'Validator',
      render: (data) => (
        <div key={data.id}>
          <b>{data.name}</b>
          <br />
          {data.description}
        </div>
      ),
    },
    {
      key: 'fields',
      header: 'Fields',
      render: (data) => (
        <div className='space-x-1 '>
          {data.field_types.map((ft) => ft.enabled && <Badge key={ft.field_type}>{ft.field_type}</Badge>)}
        </div>
      ),
    },
    {
      key: 'actions',
      header: '',
      width: '75px',
      render: (data) => (
        <Button variant='secondary' onClick={() => openEditModal(data)}>
          Edit
        </Button>
      ),
    },
  ]

  return (
    <>
      <DataTable
        caption='Field validators'
        columns={columns}
        rows={validators?.data ?? []}
        isLoading={isLoading}
        error={error}
        onRetry={refetch}
        empty={<EmptyState title='No validators found!' detail='Create a new validator to begin.' />}
        pagination={{
          currentPage: page,
          rowsPerPage: perPage,
          onPageChange: setPage,
          onRowsPerPageChange: (perPage) => {
            setPerPage(perPage)
            setPage(0)
          },
        }}
        totalRows={validators?.meta.total}
      />
      {showModal && (
        <EditModal
          validator={validator}
          fieldTypes={fieldTypes}
          onClose={() => setShowModal(false)}
          onChange={(fieldType, enabled) => onToggleChange(validator.id, fieldType, enabled)}
        />
      )}
    </>
  )
}

export default FieldValidatorsTable
